import React, {PureComponent, createRef} from 'react';
import {connect} from '~/redux/connect';
import dialogs from './dialogs';
import get from 'lodash/get';
import merge from "lodash/merge";
import { getCurrentModelId, getDialogPage, getItemId, getModelName, getParentId } from "../../stateGetter";
import { push } from 'redux-little-router';
import {compareKeys} from "mythil/object";
import { Button, dialogFactory, HStack, PortalHost, Portal, PortalProvider } from "~/native-ui";
const Dialog = dialogFactory({ PortalProvider })


const areStatePropsEqual = (prev, curr) => {
    return compareKeys(prev, curr, (prev, curr, key) => {
        switch (key) {
            case "currentModel": return compareKeys(prev, curr);
            default: return prev === curr;
        }
    })
}

export class DialogContainer extends PureComponent {
    static propTypes = {};

    state = {
        active: false
    }

    static getDerivedStateFromProps(props) {
        return {
            active: !!props.dialogPage
        }
    }

    getDialogProps() {
        return {
            active: this.state.active
        }
    }

    actionBarRef = createRef();
    setActionBarRef = (node) => this.actionBarRef.current = node;

    render() {
        if (!this.state.active) return null;

        let DialogPage = get(dialogs, `${this.props.dialogPage}.component`, (() => null));
        let dialogProps = get(dialogs, `${this.props.dialogPage}.props`, {});
        let actions = <HStack alignItems="center" ref={this.setActionBarRef}><PortalHost name="dialogContainerButtons"></PortalHost></HStack>
        
        return (
            <Dialog type="medium" { ...dialogProps } onOverlayClick={ this.props.onClose } { ...this.getDialogProps() } actions={actions}>
                <DialogPage onClose={ this.props.onClose } actionBarRef={this.actionBarRef} currentModel={ this.props.currentModel } />
                <Portal hostName="dialogContainerButtons">{ <Button label={this.props.trans("close")} onClick={ this.props.onClose } /> }</Portal>
            </Dialog>
        );
    }
}

const RXDialogContainer = connect(
    (state) => {
        const modelId = getCurrentModelId(state);
        const parentModelId = modelId && getParentId(state, modelId);

        const currentModelID = parentModelId || modelId
        return {
            dialogPage: getDialogPage(state),
            currentModel: {
                itemId: currentModelID && getItemId(state, currentModelID),
                modelName: currentModelID && getModelName(state, currentModelID),
            },
        }
    },
    (dispatch) => ({
        onClose: (options) => dispatch(push({ path: "" }, merge({ forceChangeRootModel: false }, options)))
    }),
    null,
    { areStatePropsEqual }
)(DialogContainer);

export default RXDialogContainer;